import { getValueProperty, memoize, setValueProperty } from "../helpers/functions.helpers";
import { ApplicationService } from "../services/application/application.service";
import { LinkupService } from "../services/link-up/linkup.service";
import { ITrackEventModel, IPageLoadModel } from '@dali/tagger-ng12';
import { PAGEVIEW, CHANNEL, COUNTRY, BUSINNESS, ENVIRONMENT, EVENT } from "../constants/dali.constants";
import { isObject } from "lodash";

export class BaseComponent {

    /**
     * Contiene los datos de configuración para el componente actual
     */
    private _context: any;

    private _analyticsJson: any;

    private _analyticsOriginal: any;

    private readonly PATH_SETTINGS_CONTEXT = 'context.settings';

    constructor(
        private readonly appService: ApplicationService,
        private readonly linkService: LinkupService,
        public idComponent: string
    ) {
    }

    public get context(): any {
        return this._context;
    }
    public set context(value: any) {
        this._context = value;
    }

    public get analyticsJson(): any {
        return this._analyticsJson;
    }
    public set analyticsJson(value: any) {
        this._analyticsJson = value;
    }

    async loadStaticValues() {
        this.context = getValueProperty(
            await this.linkService.settings,
            `${this.PATH_SETTINGS_CONTEXT}.${this.idComponent}`,
            {}
        );
        this._analyticsOriginal = await this.linkService.analytics;
    }


    /**
     * Permite evaluar si se debe presentar al usuario el componente en pantalla
     * @param section 
     * @returns 
     */
    isVisible(section: string) {
        return this.appService.isVisible(this.context, section);
    }

    //@memoize()
    getSetting(section: string, setting: string | null = null, defaultValue: any = null) {
        return this.appService.getSetting(this.context, section, setting, defaultValue);
    }

    async onLoad() {
        if (!this.analyticsJson) {
            this.analyticsJson = await this.linkService.analytics;
        }

        const channelsAnalytics = getValueProperty(this.appService, 'channelsAnalytics', []);

        if (channelsAnalytics.includes(this.appService.channelId)) {
            const setting = await this.linkService.settings;
            let settingAnalytics = getValueProperty(setting, "analytics", {});
            let componentAnalytics = this.getSetting("analytics", "pageLoad");
            const constants = { PAGEVIEW, CHANNEL, COUNTRY, BUSINNESS, ENVIRONMENT, navigator, componentAnalytics, settingAnalytics };
            let tempAnalytics = { ...this.analyticsJson };
            let value = "";
            for (let config of Object.keys(PAGEVIEW)) {
                let item = getValueProperty(PAGEVIEW, config, "");
                if (!getValueProperty(tempAnalytics, item.path, false)) {
                    let itemsetting = getValueProperty(componentAnalytics, item.path, false);
                    if (itemsetting) {
                        const reg = new RegExp("\{(.*?)\}", "g");
                        if (reg.test(itemsetting)) {
                            let result = itemsetting.match(reg);
                            for (let i = 0; i < result.length; i++) {
                                let item_i = result[i].replace("{", "").replace("}", "");
                                itemsetting = itemsetting.replace(result[i], getValueProperty(constants, item_i, ""));
                            }
                        }
                    }
                    setValueProperty(tempAnalytics, item.path, itemsetting);
                }
            }
            let changes: Array<IPageLoadModel> = [];
            this.processAnalytics(changes, tempAnalytics);
            this.appService.pageLoad(changes);
            this.analyticsJson = this._analyticsOriginal;
        }
    }

    async onEvent(event: ITrackEventModel) {
        const channelsAnalytics = getValueProperty(this.appService, 'channelsAnalytics', []);
        if (channelsAnalytics.includes(this.appService.channelId)) {
            this.processEvents(event, event);
            if (event.events) {
                let changes = this.eventsChanges(event.events);
                this.appService.trackEvent(event, changes);
            }
            else {
                this.appService.trackEvent(event);
            }
        }
    }

    processAnalytics(data: Array<{ path: string, value: any }>, analytics: any, path?: string) {
        if (isObject(analytics)) {
            for (let item of Object.keys(analytics)) {
                let path_temp = undefined;
                if (path) {
                    path_temp = `${path}.${item}`;
                }
                else {
                    path_temp = item;
                }
                this.processAnalytics(data, getValueProperty(analytics, item), path_temp);
            }
        }
        else {
            if (!data) {
                data = [];
            }
            if (path && analytics) {
                data.push({ path, value: analytics });
            }
        }
    }

    eventsChanges(analytics: any) {
        let changes: Array<{ path: string, value: string }> = [];
        for (var i = 0; i < analytics.length; i++) {
            changes.push({ path: analytics[i].name, value: analytics[i].value });
        }
        return changes;
    }

    processEvents(analytics: any, event: any, path?: string) {
        let componentAnalytics = this.getSetting("analytics", "trackEvent");
        let userevent = { value: "CONFIRM" };
        const constants = { EVENT, userevent, componentAnalytics };
        if (isObject(analytics)) {
            for (let item of Object.keys(analytics)) {
                let path_temp = undefined;
                if (path) {
                    path_temp = `${path}.${item}`;
                }
                else {
                    path_temp = item;
                }
                this.processEvents(getValueProperty(analytics, item), event, path_temp);
            }
        }
        else {
            if (path && analytics) {
                const reg = new RegExp("\{(.*?)\}", "g");
                if (reg.test(analytics)) {
                    let result = analytics.match(reg);
                    let item_i = result[0].replace("{", "").replace("}", "");
                    setValueProperty(event, path, getValueProperty(constants, item_i, ""));
                }
            }
        }
    }

}
